import React from 'react';
import { DatePicker, Button, Checkbox,Carousel,Menu, Icon,Modal } from 'antd'
export default class ModalUi extends React.Component{
	constructor(props, context) {
        super(props, context)
        this.state = {
            visible: false,
        }
       
    }
	goConsulting(){
	    this.setState({
	      visible: true,
	    });
  	}
  	handleOk(e) {
	    // console.log(e);
	    this.setState({
	      	visible: false,
	    });
  	}
  	handleCancel(e){
	    // console.log(e);
	    this.setState({
	      	visible: false,
	    });
  	}
	render(){
		return(
			<Modal
              title="Basic Modal"
              visible={this.state.visible}
              onOk={this.handleOk}
              onCancel={this.handleCancel}
            >
              <p>Some contents...</p>
              <p>Some contents...</p>
              <p>Some contents...</p>
            </Modal>
		)
	}
}